module.exports = __webpack_public_path__ + "img/logo.1a7c99de.svg";